/**
 * Solanaland
 *
 * Author: Phia Nasol
 * Company: Digiteer Inc.
 *
 * https://www.digiteer.digital/
 *
 */

import React from "react";
import { Accordion } from "react-bootstrap";
import { Button, Card } from "core/components";
import { useFormContext, useFieldArray } from "react-hook-form";
import ChangeOrderTaskForm from "./ChangeOrderTaskForm";
import { TaskFormData, ChangeOrderTaskFormData } from "core/schema";
import ChangeOrderTasksContext from "./ChangeOrderTasksContext";

type ChangeOrderTasksFormProps = {
  tasks: Array<TaskFormData>;
};

const ChangeOrderTasksForm = ({ changeOrder, tasks, items, isItemsLoading }: ChangeOrderTasksFormProps): JSX.Element => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray<ChangeOrderTaskFormData>({
    control,
    name: "change_order_tasks_attributes",
    keyName: "key"
  });
  const [activeKeys, setActiveKeys] = React.useState<Array<string>>(["0"]);
  const [selectedTasks, setSelectedTasks] = React.useState<Array<TaskFormData>>([]);

  const getDefaultActiveKey = (array) => {
    const lastIndex = array.length;

    return lastIndex <= 0 ? 0 : lastIndex;
  };

  const canAppendTask = () => {
    return false;
  };

  React.useEffect(() => {
    console.debug("Intensionally left empty.");
  }, [fields]);

  return (
    <React.StrictMode>
      <ChangeOrderTasksContext.Provider value={{ selectedTasks, setSelectedTasks }}>
        <Card>
          <Card.Header title="Tasks">
            <h4 className="h mr-3">Total Tasks: {fields.length}</h4>
          </Card.Header>
          <Card.Body>
            <Accordion alwaysOpen activeKey={activeKeys} onSelect={(e) => setActiveKeys(e)}>
              {fields.map((item, index) => {
                return (
                  <ChangeOrderTaskForm
                    changeOrder={changeOrder}
                    key={item.key}
                    index={index}
                    remove={remove}
                    tasks={tasks}
                    items={items}
                    isItemsLoading={isItemsLoading}
                  />
                );
              })}
            </Accordion>
            {canAppendTask() && (
              <Button
                className="button--brand mt-4"
                title="Add Task"
                icon="plus"
                type="button"
                onClick={() => {
                  append({});
                  setActiveKeys([getDefaultActiveKey(fields).toString()]);
                }}
              />
            )}
          </Card.Body>
        </Card>
      </ChangeOrderTasksContext.Provider>
    </React.StrictMode>
  );
};

export default ChangeOrderTasksForm;
